// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"139":"6e98efc2","255":"dad36810"}[chunkId] + ".css";
};